// garuda - Falling Sparks Effect

import React, { useEffect, useState } from "react";

const Sparks = () => {
  const [sparks, setSparks] = useState([]);

  useEffect(() => {
    let timeoutId;

    const createSparkCluster = () => {
      const clusterSize = Math.floor(Math.random() * 3) + 3; // 3-5 sparks per cluster
      const baseX = Math.random() * window.innerWidth;
      const sparkGroup = [];

      for (let i = 0; i < clusterSize; i++) {
        const spark = {
          id: Date.now() + Math.random() * 10000 + i,
          x: baseX + (Math.random() - 0.5) * 40, // Cluster around base position
          y: -20,
          drift: (Math.random() - 0.5) * 80,
          duration: Math.random() * 1 + 0.8, // 0.8-1.8s
          delay: Math.random() * 0.2, // Slight stagger within cluster
          isGlow: Math.random() > 0.7,
        };
        sparkGroup.push(spark);
      }

      setSparks((prev) => [...prev, ...sparkGroup]);

      // Remove sparks after animation completes
      setTimeout(() => {
        setSparks((prev) =>
          prev.filter((s) => !sparkGroup.find((sg) => sg.id === s.id)),
        );
      }, 2500);

      // Schedule next cluster after random pause (10-25s)
      const pauseDuration = Math.random() * 15000 + 10000;
      timeoutId = setTimeout(createSparkCluster, pauseDuration);
    };

    // Create first cluster
    createSparkCluster();

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div className="spark-container">
      {sparks.map((spark) => (
        <div
          key={spark.id}
          className={`spark ${spark.isGlow ? "glow" : ""}`}
          style={{
            left: `${spark.x}px`,
            top: `${spark.y}px`,
            animationDuration: `${spark.duration}s`,
            animationDelay: `${spark.delay}s`,
            "--drift": `${spark.drift}px`,
          }}
        />
      ))}
    </div>
  );
};

export default Sparks;
